// @flow
import React, { Component } from 'react'
import Scrollchor from 'react-scrollchor'

export class ScrollToTopOnMount extends Component<{}> {
  _back: null

  componentDidMount() {
    if (this._back !== null) this._back.simulateClick()
  }

  componentDidUpdate() {
    if (this._back !== null) this._back.simulateClick()
  }

  componentWillUnmount() {
    this._back = null
  }

  render() {
    return (
      <Scrollchor
        ref={ref => (this._back = ref)}
        to='main-content'
        disableHistory
      />
    )
  }
}

export default ScrollToTopOnMount
